import axios from 'axios';

let installed = false;

/**
 * 全局为同源 /api 请求附带登录 token，配合服务端 requireUserAuth。
 * 不覆盖已有 Authorization（admin / decision 等专用客户端）。
 */
export function setupAxiosAuth() {
  if (installed) return;
  installed = true;

  axios.interceptors.request.use((config) => {
    try {
      const headers = config.headers || {};
      const hasAuth = Boolean(
        headers.Authorization || headers.authorization
        || (typeof headers.get === 'function' && (headers.get('Authorization') || headers.get('authorization')))
      );
      if (hasAuth) return config;

      const token = localStorage.getItem('auth_token');
      if (!token) return config;

      const url = String(config.url || '');
      const base = String(config.baseURL || '');
      const full = `${base}${url}`;
      // 仅给站点 API；external 走 query token，不掺用户 JWT
      const isSiteApi = full.startsWith('/api/') || full.includes('/api/');
      const isExternal = full.includes('/api/external');
      if (!isSiteApi || isExternal) return config;

      if (typeof headers.set === 'function') {
        headers.set('Authorization', `Bearer ${token}`);
      } else {
        headers.Authorization = `Bearer ${token}`;
      }
      config.headers = headers;
    } catch (_) {
      /* ignore */
    }
    return config;
  });

  // 仅在「已带 token 但仍被拒」时清本地态；没带 token 的 401 不误踢登录态
  axios.interceptors.response.use(
    (res) => res,
    (error) => {
      try {
        const status = error?.response?.status;
        const code = error?.response?.data?.error;
        const url = String(error?.config?.url || '');
        const sentAuth = Boolean(
          error?.config?.headers?.Authorization
          || error?.config?.headers?.authorization
        );
        if (
          sentAuth
          && (status === 401 || status === 403)
          && (code === 'auth_required' || code === 'invalid_token' || code === 'session_expired' || code === 'membership_expired')
          && url.includes('/api/')
          && !url.includes('/api/auth/')
          && !url.includes('/api/external')
        ) {
          localStorage.removeItem('auth_token');
          window.dispatchEvent(new CustomEvent('oldox:auth-required', { detail: { status, code } }));
        }
      } catch (_) {
        /* ignore */
      }
      return Promise.reject(error);
    }
  );
}

export default setupAxiosAuth;
